import { DepartmentTypeEnum } from '../../core/types/enums';
import {
  PartnerName,
  getPartnerName,
} from '../../core/partners/partner-registry';
import { JsonProperty } from '../../core/services/utils/mapping.service';
import { Resident } from './resident.model';

export class Department {
  @JsonProperty()
  departmentType: DepartmentTypeEnum = DepartmentTypeEnum.B2C;
  @JsonProperty('departmentId')
  id: number = 0;
  @JsonProperty('color')
  color: string = '';
  @JsonProperty()
  iconUrl: string = '';
  @JsonProperty('department')
  department: string = '';
  @JsonProperty()
  departmentId: number = 0;
  @JsonProperty()
  customerId?: number = 0;
  @JsonProperty()
  peopleCount: number = 0;
  @JsonProperty()
  partnerId?: number = 0;
  @JsonProperty()
  partnerDepartmentId?: string = '';
  @JsonProperty()
  editableInShop?: number = 0;
  @JsonProperty('name')
  name: string = '';
  @JsonProperty()
  partnerLastSynchronization?: string = '';
  isChecked = false;

  constructor(init?: Partial<Department>) {
    Object.assign(this, init);
  }

  /** The partner this record belongs to, or undefined if it has none. */
  get partnerName(): PartnerName | undefined {
    return getPartnerName(this.partnerId);
  }

  get isMyNeva(): boolean {
    return this.partnerName === PartnerName.Myneva;
  }

  get isB2B(): boolean {
    return this.departmentType === DepartmentTypeEnum.B2B;
  }

  getNameWithType(): string {
    return this.isB2B ? `${this.name} (B2B)` : this.name;
  }
}

export class DepartmentWithResidents extends Department {
  @JsonProperty('department')
  department: string = '';
  @JsonProperty('name')
  name: string = '';
  @JsonProperty({ clazz: Resident, name: 'people' })
  people: Array<Resident> = [];

  constructor(init?: Partial<DepartmentWithResidents>) {
    super(init);
    Object.assign(this, init);
  }
}

export interface DepartmentFilter {
  departmentId: number;
  department: string;
  name: string;
  iconUrl: string;
}
